
/**
 * 工伤确认单
 */

 export const InjuryAffirmBillList = [
    {
        prop: "provinceName",
        label: "省",
        width: "150",
        isShow: true
    },
    {
        prop: "cityName",
        label: "市",
        width: "150",
        isShow: true
    },
    {
        prop: "regionName",
        label: "区",
        width: "150",
        isShow: true
    },
    {
        prop: "injuryUserName",
        label: "受伤人姓名",
        width: "150",
        isShow: true
    },
    {
        prop: "sex",
        label: "性别",
        width: "150",
        isShow: true,
        format: "sex",
    },
    {
        prop: "injuryUserAge",
        label: "年龄",
        width: "150",
        isShow: true
    },
    {
        prop: "isDeath",
        label: "是否死亡",
        width: "150",
        isShow: true,
        format: "checkbox",
    },
    {
        prop: "injurySiteName",
        label: "受伤部位大类",
        width: "150",
        isShow: true
    },
    {
        prop: "injurySiteDetailName",
        label: "受伤部位细分",
        width: "150",
        isShow: true
    },
    {
        prop: "injuryPartName",
        label: "伤害类型大类",
        width: "150",
        isShow: true
    },
    {
        prop: "injuryPartDetailName",
        label: "伤害类型细分",
        width: "150",
        isShow: true
    },
    {
        prop: "injuryTime",
        label: "受伤时间",
        width: "150",
        format: "date",
        isShow: true
    },
    {
        prop: "injuryDescribe",
        label: "受伤时间以及部位描述",
        width: "150",
        isShow: true
    },
    {
        prop: "injuryUnitName",
        label: "工伤单位",
        width: "150",
        isShow: true
    },
    {
        prop: "injuryTypeName",
        label: "所属行业",
        width: "150",
        isShow: true
    },
    {
        prop: "occupationDiseaseName",
        label: "职业病大类",
        width: "150",
        isShow: true
    },
    {
        prop: "occupationDiseaseDetailName",
        label: "职业病细分",
        width: "150",
        isShow: true
    },
    {
        prop: "post",
        label: "岗位",
        width: "150",
        isShow: true
    },    
    {
        prop: "entryDate",
        label: "入职时间",
        width: "150",
        format: "date",
        isShow: true
    },    
    {
        prop: "cultureLevel",
        label: "文化程度",
        width: "150",
        isShow: true
    },
    {
        prop: "applyTime",
        label: "申请时间",
        width: "150",
        isShow: true
    },
    {
        prop: "applyUser",
        label: "申请人",
        width: "150",
        isShow: true
    },
    {
        prop: "acceptanceTime",
        label: "受理时间",
        width: "150",
        isShow: true
    },
    {
        prop: "handler",
        label: "审批人",
        width: "150",
        isShow: true
    },
    {
        prop: "injuryAddress",
        label: "工伤地点",
        width: "150",
        isShow: true
    },
    {
        prop: "complianceClause",
        label: "符合条款",
        width: "150",
        isShow: true
    },
    {
        prop: "applyDetermination",
        label: "认定决定",
        width: "150",
        isShow: true
    },
    {
        prop: "applyDeterminationNumber",
        label: "认定书编号",
        width: "150",
        isShow: true
    },
    {
        prop: "reviewSignatureTime",
        label: "审签时间",
        width: "150",
        isShow: true
    },
    {
        prop: "processBatch",
        label: "处理批次",
        width: "150",
        isShow: true
    },
    {
        prop: "remarks",
        label: "备注",
        width: "150",
        isShow: true
    },
]

